import React, { useState, useEffect } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import { useCategory } from '../contexts/CategoryContext';
import { useAuth } from '../contexts/AuthContext';
import { CFormLabel } from '@coreui/react';

function CategorySelection({
    value,
    onChange,
    className,
    labelClassName,
    multiSelect = true,
    required = false,
    error = false,
    placeholder = 'Select category...',
    label = null ? '' : 'Category',
    disabled = false
}) {

    const requiredIcon = required ? <span className="text-danger">*</span> : null;

    const { restaurantId } = useAuth();
    const { getAllCategories } = useCategory();

    const [totalRenderedRecords, setTotalRenderedRecords] = useState(0);
    const [filter, setFilter] = useState({
        modifiers: null,
        restaurant_id: restaurantId,
        limit: 50,
        totalRenderedRecords: totalRenderedRecords,
        filter: null,
    });

    const [key, setKey] = useState(0);
    useEffect(() => {
        if (restaurantId) {
            setFilter({ ...filter, restaurant_id: restaurantId });
        }
    }, [restaurantId]);

    useEffect(() => {
        setKey((prevKey) => prevKey + 1);
    }, [restaurantId]);

    const fetchCategories = async (searchValue, loadedOptions, { totalRenderedRecords }) => {
        try {
            if (restaurantId) {
                const response = await getAllCategories({ ...filter, filter: searchValue, totalRenderedRecords });

                if (response.totalPages > 0) {
                    const newOptions = response.categories.length > 0 && response.categories.map((category) => ({
                        label: category.name,
                        value: category.id,
                    }));

                    const hasMore = totalRenderedRecords + newOptions.length < response.totalCount;

                    return {
                        options: newOptions,
                        hasMore: hasMore,
                        additional: {
                            totalRenderedRecords: totalRenderedRecords + filter.limit,
                        },
                    };
                } else {
                    return {
                        options: [],
                        hasMore: false,
                        additional: null,
                    };
                }
            }
        } catch (error) {
            console.error('Error fetching categories', error);
            return {
                options: [],
                hasMore: false,
                additional: null,
            };
        }
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            whiteSpace: state.isFocused ? 'pre-wrap' : 'nowrap',
            wordBreak: state.isFocused ? 'break-all' : null,
            wordWrap: state.isFocused ? 'break-word' : null,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }),
    };

    return (
        <div key={key} className={className}>
            {
                label !== null && (
                    <div className={labelClassName}>
                        <CFormLabel>{label} {requiredIcon}</CFormLabel>
                    </div>
                )
            }
            <div className='w-100'>
                <AsyncPaginate
                    className={`${(error && required) && 'multiSelect_error'} `}
                    value={value}
                    loadOptions={fetchCategories}
                    isMulti={multiSelect}
                    closeMenuOnSelect={!multiSelect ? true : false}
                    onChange={onChange}
                    placeholder={placeholder}
                    isDisabled={disabled}
                    noOptionsMessage={() => ('No categories found')}
                    loadingMessage={() => ('Categories Loading...')}
                    additional={{
                        totalRenderedRecords: totalRenderedRecords,
                    }}
                    SelectProps={{
                        isSearchable: true,
                    }}
                    menuShouldScrollIntoView={false}
                    menuPortalTarget={document.querySelector('body')}
                    styles={customStyles}
                />
                {(error && required) && <span className="text-danger error_message">Please select any one category.</span>}
            </div>
        </div>
    );
}

export default CategorySelection;
